import { render, staticRenderFns } from "./BrowserWindow.vue?vue&type=template&id=f0670224"
import script from "./BrowserWindow.vue?vue&type=script&lang=js"
export * from "./BrowserWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports